import styles from './MyProfilePage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import { commonActions } from '../../stores/_actions';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import { ProfileBar } from 'views/components/profile-bar/ProfileBar';
import { Profile } from '../components/profile/Profile';
import mainProfile from 'assets/images/main-profile.jpg';

function MyProfilePage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };
  let userProfile = useSelector((state) => state.getCustDetails.data);
  const dispatch = useDispatch();
  useEffect(() => {
    userProfile = userProfile == undefined ? dispatch(commonActions.getCustDetailsByCode(payload)) : '';
    dispatch(commonActions.getCustDetailsByCode(payload));
  }, []);

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <ProfileBar profile={userProfile} />
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <h1>My Profile</h1>
              <Profile userProfile={userProfile} />
              <div className={styles.pageLeft__right}>
                <img src={userProfile && userProfile.ProfImage} alt="" />
              </div>
            </div>
            {/* <div className={styles.pageRight}>&nbsp;</div> */}
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { MyProfilePage };
